import { localize } from "lib/i18n/localization";

const Title = localize({
  en_GB: <>Confirm the member's preferred name</>,
  sv_SE: <></>,
});

export const Trans = { Title };
